<template>
  <div>
    <div v-if="showloading">

      <loader-appie/>

    </div>
<!--    <sidebar-home-one :sidebar="sidebar" :side="SideMenu" @toggleSidebar="toggleSidebar" :menuItems="navs"/>-->
<!--    &lt;!&ndash;====== OFFCANVAS MENU PART ENDS ======&ndash;&gt;-->

<!--    &lt;!&ndash;====== APPIE HEADER PART START ======&ndash;&gt;-->

<!--    <header-home-two @toggleSidebar="toggleSidebar" :side="SideMenu" :titleWordd="titleWord" :custCare="customerCare"-->
<!--                     :menuItems="navs"/>-->
  <section class="appie-testimonial-2-area " id="testimonial">
      <div class="container" v-if="!showloading">
        <div class="row">
          <div class="col-md-3 whitebackground menudiv" >
            <menubar @toggleSidebar="toggleSidebar" :side="SideMenu" :titleWordd="titleWord" :custCare="customerCare" :menuItems="navs"/>
          </div>
          <div class="col-md-9  graybackground contentdiv" >

              <div class="col-lg-12 mt-2">
                <div class="">

                  <Commonprofile/>
                </div>

<div class="" v-if="list.length > 0">


    <div class="mt-2"> <b class="">{{ title }}</b></div>

  <div class="row">
  <div class="col-md-6 col-lg-6 col-12 scrollable"   @scroll="handleScroll" ref="scrollableDiv">
    <div  class="row">


      <!--              <div v-if="list.length > 0">-->
      <div class="col-12 col-sm-12 col-lg-12 col-md-12 mb-10 " v-for="(ListData,index) in list" :key="index">



        <div class="card"  @click="OpenEmployeeView(ListData.activity,ListData.url)">
          <div class="card-body p-2">
            <div class="row">
              <div>
                <p class="text-end">{{ ListData.cdate }}</p>
              </div>
            </div>
            <div class="row">

              <div class="col-2 col-md-2 col-lg-2 ">

                          <span class="badge  rounded-circle d-flex justify-content-center align-items-center countbadge">      {{ index + 1 }}</span>
              </div>
              <div class="col-10 col-md-10 col-lg-10 ">

                <p class="textleft" style="font-weight: bold;" >{{cleanName(ListData.name)}}</p>
                <p class="textleft">{{ ListData.mobile1 }}</p>
                <p class="textleft">{{ ListData.address }}</p>
              </div>

            </div>
          </div>

        </div>
      </div>
      <span v-if="loading" style="text-align: center">
           <loader-appie/>

<!--        loading...-->
      </span>
    </div>

  </div>
  <div class="col-md-6 col-lg-6 col-12">
<!--    <pre>{{ singleViewdata }}</pre>-->
<div  v-if="showsingleview">
    <div class="row d-flex flex-wrap align-items-center">



    </div>

    <div class="row mt-2 ">
      <!--                <div class="card" v-if="list.groupCard" :style="{backgroundColor:list.groupCard[0].bgColor,width: '90%',margin: 'auto'}" >-->

      <div class="row mt-2">
        <div class="col-4 col-sm-12 col-lg-4" v-for="(multiCardcount,index) in singleViewdata.multiCard"
             :key="index">
          <div class="" style="width: 100%" v-if="multiCardcount.visible==1" @click="countmpage(multiCardcount.activity,multiCardcount.url)">
            <div class="card-body p-0">
              <p><span v-html="multiCardcount.title"></span></p>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="col-12 col-sm-12 col-lg-12 mt-2  temp_10_space">
      <!--                <div v-if="list.groupCard">-->
      <div class="row">
        <div class="col-12 col-md-12 col-lg-12">

          <div v-for="(groupCardlist,index) in singleViewdata.groupCard" :key="index">
            <div class="" style="background-color:#4D5BE1">
              <div class="p-1">

                <div class="row">

                  <div class="col-12  col-md-12 col-lg-12 text-end">
                        <span class="badge rounded-pill bg-warning text-dark"><span
                            v-html="groupCardlist.noofvancancy"></span></span>

                  </div>
                </div>
<!--                <div class="row">-->
<!--                  <div class="col-12  col-md-12 col-lg-12  " style="text-align: center">-->
<!--                    <img :src="groupCardlist.image" class="logosize">-->


<!--                  </div>-->
<!--                </div>-->
                <div class="row">
                  <div class="col-12  col-md-12 col-lg-12 m-1 fontboldweightlight"  >

                    <b class="textleft" v-html="cleanName(groupCardlist.jobtitle)"></b>
                    <p class="textleft " v-html="groupCardlist.employer"></p>
                    <p class="textleft " v-html="groupCardlist.joblocation"></p>
                    <b class="textleft fontboldwight" v-html="groupCardlist.jobType" style="color: white!important;"></b>

                  </div>
                </div>

                <div class="row mt-2">
                  <div class="col-12 col-lg-4 col-md-4 mb-2" v-for="(MulticardData,index) in groupCardlist.multiCard"
                       :key="index">
                    <div class="multigardgrid"  v-if="MulticardData.visible==1">
<!--                      <div class="card-body p-0">-->
                      <span v-html="MulticardData.title"></span>
<!--                      </div>-->
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div class="col-12 coml-md-12 col-lg-12">
          <div class="card mb-2 mt-2">
            <div class="card-body">
              <div class="row mt-2 ">
                <div class="col text-end">
                  <div v-for="(buttonViewData,index) in buttonView" :key="index"  style="display: inline-block;">
                    <div v-if="buttonViewData.visible == '1'">
                      <div v-if="index == 0">
                      <span class="badge rounded-pill bg-dark" @click="EditJob(buttonViewData.url)"><span
                          v-html="buttonViewData.title"
                          :style="{backgroundColor:bgColor,fontSize: '0.7rem',padding: '0.5rem 1rem'}"></span></span>
                      </div>
                      <div v-else>

                        <img :src="buttonViewData.icon[0]" alt="" class=""
                             :style="{ width: '20% !important', border: buttonViewData.value == 1 ? '2px solid blue' : 'none' }"
                             @click="shortlisturl(buttonViewData.action.url,index)">
                      </div>

                    </div>
                  </div>
                  <br>
                  <span v-if="istoastMessage" class="shortlist-toaster">{{toastMessage}}</span>
                </div>
                <!--                <div class="card" v-if="list.groupCard" :style="{backgroundColor:list.groupCard[0].bgColor,width: '90%',margin: 'auto'}" >-->
                <div v-for="(CommunicationInfo,index) in singleViewdata.singleCard" :key="index" class="col-12 col-md-12 mb-2">
                  <!--                    <div class="card mb-2">-->
                  <!--                      <div class="card-body">-->

                  <p v-html="CommunicationInfo.title" style="text-align: left"></p>

                  <div v-for="(CommunicationInfoData,index) in CommunicationInfo.list" :key="index" class="row">
                    <div class="col-md-3">
                      <p v-html="CommunicationInfoData.title" style="text-align: left"></p>
                    </div>
                    <div class="col-md-9">
                      <p v-html="CommunicationInfoData.content ?CommunicationInfoData.content:'------'" style="text-align: left"></p>
<!--                      <p style="text-align: left">: <span v-html="CommunicationInfoData.content ? CommunicationInfoData.content : '&#45;&#45;&#45;&#45;&#45;&#45;'"></span></p>-->

                    </div>

                    <!--                        </div>-->
                    <!--                      </div>-->
                  </div>

                </div>

              </div>

            </div>
          </div>
        </div>


      </div>




<!--      <div v-if="openCall">-->
<!--        &lt;!&ndash;                <button>{{navButton}}</button>&ndash;&gt;-->
<!--        <div v-if="navButton.visible == '1'">-->
<!--          <button type="button" class="btn"-->
<!--                  :style="{backgroundColor:navButton.bgColor,fontSize:navButton.textSize}"-->
<!--                  @click="callMobileNumber(navButton.value)"><span v-html="navButton.title"></span></button>-->
<!--        </div>-->
<!--      </div>-->
    </div>

</div>

  </div>
  </div>

</div>

                <div v-else>
                  <div class="card mt-5 messagediv">
                    <div class="card-body" style="text-align: center;">

                      <h5><span style="color: blue">Data Not</span> <span style="color: red;">Found!</span></h5><br>
                      <span style="color: black;font-weight: 800;">நீங்கள் தேடிய தகவல் தற்போது இல்லை</span>
                      <br>
                      <br>
                      <!--                  <button type="button" @click="navigateToSamePage" class="btn btn-success">Exit</button>-->


                    </div>
                  </div>
                </div>


              </div>

<!--              </div>-->

          </div>
        </div>



      </div>

      <div>
        <b-modal id="modal-center1" centered title="BootstrapVue">
          <div class="row">
            <!-- First Card Row -->
            <div class="col-12 col-lg-12 col-md-12 mb-4" v-for="(customerCareData,index) in customerCare" :key="index">
              <span v-html="stripTags(customerCareData.label)"></span>


              <div class="card" >
                <div class="card-body">
                  <div class="row align-items-center">
                    <div class="col-2 col-lg-2 col-md-2">
                      <div class="d-flex justify-content-center align-items-center h-100">
                        <i class="fa fa-phone flipped" style="background: white;" aria-hidden="true"></i>
                      </div>
                    </div>
                    <div class="col-8 col-lg-8 col-md-8">
                      <div class="d-flex flex-column justify-content-center h-100">
                        <span>{{ customerCareData.name }}</span>
                        <span v-html="customerCareData.description"></span>
                      </div>
                    </div>
                  </div>


                </div>
              </div>
            </div>
          </div>
        </b-modal>
      </div>
    </section>



    <div class="back-to-top back-to-top-2">
      <a href="#"><i class="fal fa-arrow-up"></i></a>
    </div>
    <!--====== APPIE BACK TO TOP PART ENDS ======-->
  </div>
</template>

<script>

import CryptoJS from "crypto-js";
import video_bg_thumb from "@/assets/images/video-thumb-1.jpg"
import hero_img from '@/assets/images/hero-thumb-3.png'
// import HeaderHomeTwo from '../HomePage/Header.vue'
// import SidebarHomeOne from '../HomeOne/SidebarHomeOne.vue'

import {callAxiosWithConfig} from "@/main";
import {right} from "core-js/internals/array-reduce";
import LoaderAppie from "@/components/LoaderAppie.vue";
import Menubar from "@/components/HomePage/menu.vue";
import Commonprofile from "@/components/HomePage/commonprofilediv.vue";

export default {
  props: {
    section_heading: {
      type: String,
    },
    more_heading: {
      type: String
    },
    description: {
      type: String
    },
    grid_items: {
      type: Array,
    }
  },
  components: {
    Commonprofile,
    Menubar,
    LoaderAppie,
    // HeaderHomeTwo,
    // HeroHomeTwo,

    // FooterHomeTwo,
    // SidebarHomeOne,
  },
  data() {
    return {
      showsingleview:false,
      loading:false,
      isFetchingData: false,
      lastId:0,
      showloading:false,
      SideMenu: {},
      titleWord: '',
      customerCare: {},
      title: '',
      textSize: '',
      countView: [],
      list: [],
      singleViewdata:[],
      ListTitleData: [],
      ListButtonData: [],
      buttonView: [],
      istoastMessage:false,
      bgColor: '',
      template: '',
      urlData: '',
      ViewPosttitle: '',
      sidebar: false,
      navs: [
        {
          // name:'contact',
          name: 'Home',
          path: '/home-page'
        },
        {
          name: 'Profile',
          childrens: [
            {
              // name:'Home 1',
              name: 'Update KYC',
              path: '/'
            },
            {
              // name:'Home 2',
              name: 'Update Profile',
              path: '/home-two'
            },
            {
              // name:'Home 3',
              name: 'View Profile',
              path: '/home-three'
            },
            {
              // name:'Home 4',
              name: 'Viewed Profiles',
              path: '/home-four'
            },
            {
              // name:'Home 5',
              name: 'Change Mobile Number',
              path: '/home-five'
            },
            // {
            //   name:'Home 6',
            //   path:'/home-six'
            // },
            // {
            //   name:'Home 7',
            //   path:'/home-seven'
            // },
            // {
            //   name:'Home 8',
            //   path:'/home-eight'
            // },
          ],
        },
        // {
        //   name:'service',
        //   path:'/service-details'
        // },
        // {
        //   name:'pages',
        //   childrens:[
        //     {
        //       name:'About us',
        //       path:'/about-us'
        //     },
        //     {
        //       name:'Error',
        //       path:'/error'
        //     }
        //   ],
        // },
        // {
        //   name:'news',
        //   childrens:[
        //     {
        //       name:'News',
        //       path:'/news'
        //     },
        //     {
        //       name:'Single news',
        //       path:'/single-news'
        //     },
        //   ],
        // },
        {
          // name:'contact',
          name: 'Customer Care',
          path: '/contact'
        },
        // {
        //   // name:'contact',
        //   name:'Notification',
        //   path:'/notifi'
        // }
      ],
      hero_img: hero_img,
      video_bg_thumb: video_bg_thumb
    }
  },


  mounted() {
    document.addEventListener('scroll', this.topToBottom)
  },

  async created() {
    this.showloading=true;
    if (this.$route.query.page) {

      const pageurl = this.$route.query.page;
      const decryptedString = this.decryptUrl(pageurl);
      this.modifiedString = decryptedString;
      try {

        const PaymentHistoryData = await callAxiosWithConfig(this.modifiedString, {'lastId': 0, 'listSize': 0}, 'post');
        // const PaymentHistoryData = await callAxiosWithConfig('https://jobspro.nithrajobs.com/api/' + this.modifiedString, {'lastId': 0,'listSize':0}, 'post');

        // console.log(PaymentHistoryData.title);
        this.title = PaymentHistoryData.title;
        this.countView = PaymentHistoryData.countView;
        this.list = PaymentHistoryData.list;
        this.showloading=false;
        if(PaymentHistoryData.status == true){
          if (PaymentHistoryData.list.length > 0) {
            this.lastId = PaymentHistoryData.list[PaymentHistoryData.list.length - 1].id;
          }
        }
        this.SideMenu = JSON.parse(localStorage.getItem("SideMenu"));
        this.titleWord = JSON.parse(localStorage.getItem("titleWord"));
        this.customerCare = JSON.parse(localStorage.getItem("customerCare"));

        console.log(this.SideMenu)
        this.$emit("tempData", this.SideMenu);
        this.$emit("title", this.titleWord);
        this.$emit("customerCare", this.customerCare);

      } catch (error) {
        if (error.response && error.response.status === 401) {
          // Handle 401 status silently
          // For example, do nothing or log a message without displaying it
        } else {
          // Handle other errors by displaying them
          console.error('Error in Axios request:', error);
        }
      }
// alert(this.modifiedString )
      // this.EditId = this.$route.query.id;
      // this.decryptedValue = this.Decrypt(this.encryptedParam);
      // this.modifiedString = this.decryptedValue.replace(/-/g, '/');
    }


    // window.addEventListener('scroll', this.handleScroll);
    // document.addEventListener('DOMContentLoaded', () => {
    //   const scrollableDiv = document.querySelector('.scrollable');
    //   if (scrollableDiv) {
    //     scrollableDiv.addEventListener('scroll', this.handleScroll);
    //   }
    // });

  },

  methods: {

   async handleScroll() {
     if (this.isFetchingData) {
       // alert(this.isFetchingData)
       return;
     }
        // Check if the user has scrolled to the bottom of the page
     // const scrollableDiv = document.querySelector('.scrollable');
     // if (scrollableDiv) {
     //   const distanceToBottom = scrollableDiv.scrollHeight - (scrollableDiv.clientHeight + scrollableDiv.scrollTop);



     const scrollableDiv = this.$refs.scrollableDiv;
     const distanceToBottom = scrollableDiv.scrollHeight - (scrollableDiv.clientHeight + scrollableDiv.scrollTop);

       // const distanceToBottom = document.documentElement.scrollHeight - (window.innerHeight + window.scrollY);
        if (distanceToBottom < 100) {
          // alert('in')
          this.isFetchingData = true;
          this.loading=true;
          const loadmoreData = await callAxiosWithConfig(this.modifiedString, {'lastId': this.lastId, 'listSize': 0}, 'post');
          if(loadmoreData.status == true){
            // console.log(loadmoreData)
            if (loadmoreData.list.length > 0){
              this.list = [...this.list, ...loadmoreData.list];
              // Update the lastId with the id of the last element in the new data
              this.lastId = loadmoreData.list[loadmoreData.list.length - 1].id;
              this.isFetchingData = false;
              this.loading=false;

            }
            else{
              this.loading=false;
            }


          }
          else{
            this.loading=false;
          }

        }
      // }
     },

    encryptUrl(url) {
      const ciphertext = CryptoJS.AES.encrypt(url, 'secret key 123').toString();
      return ciphertext;
    },
    decryptUrl(ciphertext) {
      const bytes = CryptoJS.AES.decrypt(ciphertext, 'secret key 123');
      const originalUrl = bytes.toString(CryptoJS.enc.Utf8);
      return originalUrl;
    },

    stripTags(html) {
      // Regular expression to remove HTML tags
      return html.replace(/<[^>]+>/g, '');
    },

    cleanName(name) {
      if (name.includes('%')) {
        // If the name starts with '%', it's URL-encoded
        try {
          let namecon= decodeURIComponent(name);
          if (namecon.includes('+')){
            return namecon.replace(/\+/g, ' ');
          }
          else{
            return namecon;
          }
        } catch (error) {
          console.error("Error decoding name:", error);
          return name; // Return original name if decoding fails
        }
      } else {
        // If the name doesn't start with '%', it's not URL-encoded
        // Replace '+' with space
        return name.replace(/\+/g, ' ');
      }
    },


    navigateToSamePage() {
      this.$router.go(-1);
    },

    Decrypt(str) {
      return str.replace(/[a-zA-Z]/g, function (char) {
        const charCode = char.charCodeAt(0);
        const decryptedCharCode = charCode - 1; // Decryption logic
        return String.fromCharCode(decryptedCharCode);
      });
    },

    right,
    topToBottom() {
      const result = document.querySelector('.back-to-top')
      if (document.body.scrollTop > window.innerHeight || document.documentElement.scrollTop > window.innerHeight) {
        result.style.display = "block";
      } else {
        result.style.display = "none";
      }
    },
    toggleSidebar() {
      this.sidebar = !this.sidebar
    },

    async GetPlan(activity, url) {
      // alert(activity)
      // alert(url)

      const inputString = activity;
      const lastPart = inputString.split('.').pop();
      // alert(lastPart);
      this.urlData = url;

      if (lastPart === 'Employer_Common_Webview_Activity') {


        window.location.href = this.urlData
      }
    },

    async OpenEmployeeView(activity, url) {
      // alert(activity)
      // console.log(activity)
      // console.log(url)
      // alert(url)

      const inputString = activity;
      const lastPart = inputString.split('.').pop();
      this.urlData = url;

      if (lastPart === 'Employer_Dynamic_Job_View') {
        this.singleemployeeview(url);
        this.showsingleview=true;
        // const encryptedString = this.encryptUrl(url);
        // await this.$router.push(`/post-view?page=${encodeURIComponent(encryptedString)}`);
      } else if (lastPart === 'Employer_Common_Webview_Activity') {

        const encryptedString = this.encryptUrl(url);
        await this.$router.push(`/plan-purchase?page=${encodeURIComponent(encryptedString)}`)
        // // console.log('xfgs')
        // window.location.href = this.urlData;
      }
    },
    async singleemployeeview(url){

      this.modifiedString=url;
      const singleViewPostData = await callAxiosWithConfig(this.modifiedString, '', 'post');
      // this.showloading=false;
      // this.title = singleViewPostData.title;
      this.buttonView = singleViewPostData.buttonView;
      this.singleViewdata = singleViewPostData.list;

    },
    async shortlisturl(url,indexvalue){


      const ViewPostData = await callAxiosWithConfig(url, '', 'post');
      // console.log(ViewPostData);

      if(ViewPostData.status == true){
        let toastmsg=ViewPostData.message;
        let value=ViewPostData.value;

        if(value == 1){
          this.$set(this.buttonView[indexvalue], 'value', 1);
        }
        else{
          this.$set(this.buttonView[indexvalue], 'value', 0);
        }
        this.verifyviewmsgtoaster(toastmsg);
      }
      else{
        let toastmsg=ViewPostData.message;
        this.verifyviewmsgtoaster(toastmsg);


      }

    },
    verifyviewmsgtoaster(message) {
      // Set the message
      this.istoastMessage=true;
      this.toastMessage = message;
      setTimeout(() => {
        this.istoastMessage=false;
        this.toastMessage = ''; // Clear the message after 3 seconds

      }, 3000); // Adjust the duration as needed
    },


    Encrypt(str) {
      // return str.split('').map(char => char.charCodeAt(0)).join('-');
      return str.replace(/[a-zA-Z]/g, function (char) {
        // Replace each alphabetic character with its encrypted value
        const charCode = char.charCodeAt(0);
        const encryptedCharCode = charCode + 1; // You can use a different encryption logic
        return String.fromCharCode(encryptedCharCode);
      });
    },
  }

}
</script>

<style>
.appie-features-box-item {
  padding: 10px 12px 12px 10px;
}

.appie-features-box-item.item-2:hover {
  border-color: unset;
}
.messagediv{
  width: 100%;margin: auto;
}
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .temp_10 {
    min-height: 100px;
    border: unset;
    width: 100%;
    border-radius: 10px;
  }

  .temp_10_space {
    margin-bottom: 30px;
  }

  .imageSize {
    width: 10%;
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media (min-width: 600px) and (max-width: 767px) {

}

@media (min-width: 768px) and (max-width: 991px) {

}
@media (min-width: 768px) {
  .messagediv{
    width: 50%;margin: auto;
  }

}


/* Medium devices (landscape tablets, 768px and up) */

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {

}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .temp_10 {
    border: unset;
    width: 100%;
    min-height: 200px;
    border-radius: 10px;

  }

  .text_space {
    margin-top: 10px;
  }

  .imageSize {
    width: 4%;
  }

}
.scrollable {
  //width: 300px;
  height: 100vh; /* Adjust height as needed */
  overflow: auto; /* or overflow: scroll; */
  //border: 1px solid #ccc;
  padding: 10px;
}
.scrollable::-webkit-scrollbar {
  width: 6px; /* Set the width of the scrollbar */
}
.scrollable::-webkit-scrollbar-thumb {
  background-color: #aaa; /* Set the color of the scrollbar thumb */
}

.multigardgrid{
  border-radius: 4px;
  text-align: center;
  width: 100%;
  font-size: 15px;
  background: white;
}
.headtitle{
  font-weight: 800;
  background: white;
  padding: 10px;
  margin-bottom: 5px;
}
</style>
